import React from 'react';
import axios from 'axios';
import { fetchFaculties, fetchAcademicYears, fetchCountries, fetchCantonss } from '../Lookups/util';
import { citizenshipTypeOptions} from './util';
import { Table, Form, Header, Segment, Loader, Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const fetchCantons = (faculty, academicYear) => axios.get(`/statistics/enrolled-per-canton-for-BiH?facultyId=${faculty}&academicYearId=${academicYear}`);
const fetchEntities = (faculty, academicYear) => axios.get(`/statistics/enrolled-per-entity-for-BiH?facultyId=${faculty}&academicYearId=${academicYear}`);
const fetchForeignCountries = (faculty, academicYear) => axios.get(`/statistics/enrolled-per-foreign-country?facultyId=${faculty}&academicYearId=${academicYear}`);

class EnrolledStudentsPerCountries extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faculties: [],
            faculty: '',
            academicYears: [],
            academicYear: '',
            citizenship: '',
            countries: [],
            entitiesAndCantonsData: [],
            foreignCountriesData: [],
            cantons: [],
            entitiesData: [],

            loading: true,
            showChart: false
        };

        this.fetchFacultiesCountriesCantonsAndAcademicYears = this.fetchFacultiesCountriesCantonsAndAcademicYears.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getCountryName = this.getCountryName.bind(this);
        this.getCantonName = this.getCantonName.bind(this);
        this.getEntityName = this.getEntityName.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getChartDataToRender = this.getChartDataToRender.bind(this);
        this.countStudentsFromBiH = this.countStudentsFromBiH.bind(this);
    }


    componentDidMount() {
        this.fetchFacultiesCountriesCantonsAndAcademicYears();
    }

    getFacultyName() {
        const { faculties, faculty } = this.state;
        const selected = faculties.find(el => el.id === faculty);
        if (selected && selected.name) return selected.name;
        return '';
    }
    getCountryName(id) {
        const { countries } = this.state;
        const selected = countries.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getEntityName(id) {
        if (id === 2) return 'Republika Srpska';
        else if (id === 3) return 'Brčko Distrikt';
        return 'Federacija BiH';
    }

    getCantonName(id) {
        const { cantons } = this.state;
        const selected = cantons.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    fetchFacultiesCountriesCantonsAndAcademicYears() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchCountries(), fetchCantonss()])
            .then(axios.spread((facultiesRes, academicYearsRes, countriesRes, cantonsRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const countries = countriesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const cantons = cantonsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYears, faculties, countries, cantons, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch faculties or academic years or countries');
            });
    }


    generateChartData() {
        const { faculty, academicYear } = this.state;
        axios.all([fetchEntities(faculty, academicYear), fetchCantons(faculty, academicYear), fetchForeignCountries(faculty, academicYear)])
            .then(axios.spread((etitiesRes, cantonsRes, foreignCountriesRes) => {
                const entitiesData = etitiesRes.data.sort((a, b) => b.numberOfStudents - a.numberOfStudents).map(el => ({
                    ...el, name: this.getEntityName(el.placeId), value: el.numberOfStudents
                }));
                const cantonsData = cantonsRes.data.sort((a, b) => b.numberOfStudents - a.numberOfStudents).map(el => ({
                    ...el, name: this.getCantonName(el.placeId), value: el.numberOfStudents
                }));
                const foreignCountriesData = foreignCountriesRes.data.sort((a, b) => b.numberOfStudents - a.numberOfStudents).map(el => ({
                    ...el, name: this.getCountryName(el.placeId), value: el.numberOfStudents
                }));
                this.setState({
                    entitiesData, entitiesAndCantonsData: [...cantonsData, ...entitiesData], foreignCountriesData, loading: false, showChart: true
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch entities or canton or forign countries');
            });
    }

    countStudentsFromBiH() {
        const { entitiesAndCantonsData } = this.state;
        const count = entitiesAndCantonsData.reduce((a, c) => a + c.value, 0);
        return {
            name: 'BiH',
            value: count
        };
    }
    getChartDataToRender() {
        const {
            entitiesData, foreignCountriesData, citizenship
        } = this.state;
        if (citizenship === 0) {
            return entitiesData;
        } else if (citizenship === 1) {
            return foreignCountriesData;
        } else if (citizenship === 2) {
            return foreignCountriesData;
        }
        return [];
    }

    getDataToRender() {
        const {
            entitiesAndCantonsData, foreignCountriesData, citizenship
        } = this.state;
        if (citizenship === 0) {
            return entitiesAndCantonsData;
        } else if (citizenship === 1) {
            return foreignCountriesData;
        } else if (citizenship === 2) {
            return [this.countStudentsFromBiH(), ...foreignCountriesData];
        }
        return [];
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="professorStatistics.statistics" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectFacultyAndAcademicYear" />}
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.faculty" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectFaculty" />}
                                        value={this.state.faculty}
                                        onChange={this.handleInputChange}
                                        name="faculty"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>{<FormattedMessage id="statistics.citizenship" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectCitizenship" />}
                                        value={this.state.citizenship}
                                        onChange={this.handleInputChange}
                                        name="citizenship"
                                        options={citizenshipTypeOptions}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Button label=" " color="blue" basic="true"  onClick={this.generateChartData}>{<FormattedMessage id="common.show" />} </Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Grid columns="equal" centered className="stackable">

                    <Grid.Row stretched>
                        <Grid.Column>
                            <Header as="h2">
                                {this.getFacultyName()}
                            </Header>
                            <Header as="h3">{<FormattedMessage id="statistics.headerNumberEnrolledStudents" />} {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />}</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment>
                                    <Header as="h3">{<FormattedMessage id="statistics.tableShow" />}</Header>
                                </Segment>
                                {this.getDataToRender().length ? <Segment>
                                    <Table compact celled selectable>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>{<FormattedMessage id="statistics.place" />}</Table.HeaderCell>
                                                <Table.HeaderCell>{<FormattedMessage id="statistics.numberOfStudents" />}</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>  {this.getDataToRender().map((el) =>

                                            (<Table.Row key={el.name}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.value}
                                                </Table.Cell>
                                            </Table.Row>))}
                                        </Table.Body>
                                    </Table>
                                    <br />
                                </Segment>
                                    : <Segment>
                            Nema podataka za odabranu akademsku godinu.
                                    </Segment>}
                            </Segment.Group >
                        </Grid.Column>

                        {/* <Grid.Column>
                            <Segment.Group raised>
                                <Segment>
                                    <Header as="h3">{<FormattedMessage id="statistics.graphicShow" />}</Header>
                                </Segment>
                                <Segment>
                                    <br />
                                    <PieChart style={center} width={400} height={400}>
                                        <Pie
                                            data={this.getChartDataToRender()}
                                            innerRadius={20}
                                            outerRadius={140}
                                            paddingAngle={5}
                                            label={llabel}
                                        >
                                            {
                                                this.getChartDataToRender().map((entry, index) => <Cell fill={CountriesColors[index % CountriesColors.length]} />)
                                            }
                                        </Pie>
                                        <Legend
                                            iconType="circle"
                                            iconSize={15}
                                            width={400}
                                            height={80}
                                            verticalAlign="bottom"
                                            wrapperStyle={{
                                                lineHeight: '35px',
                                                left: '15px'
                                            }}
                                        />
                                        <Tooltip />
                                    </PieChart>

                                    <br />
                                </Segment>

                            </Segment.Group>
                        </Grid.Column> */}
                    </Grid.Row>
                </Grid>}
            </div>
        );
    }
}

export default EnrolledStudentsPerCountries;



// WEBPACK FOOTER //
// ./src/views/Statistics/EnrolledStudentsPerCountries.js